import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@material-ui/core';
import InputLabel from '~/components/InputLabel';

import { Container } from './styles';

const ptDays = [
  { id: '0', value: '0', label: 'Dom.' },
  { id: '1', value: '1', label: 'Seg.' },
  { id: '2', value: '2', label: 'Ter.' },
  { id: '3', value: '3', label: 'Qua.' },
  { id: '4', value: '4', label: 'Qui.' },
  { id: '5', value: '5', label: 'Sex.' },
  { id: '6', value: '6', label: 'Sáb.' },
];

const Days = ({ name }) => {
  const inputRefs = useRef([]);
  const {
    fieldName,
    registerField,
    defaultValue = [],
    error,
    clearError,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs) => {
        return refs.filter((ref) => ref.checked).map((ref) => ref.value);
      },
      clearValue: (refs) => {
        refs.forEach((ref) => {
          ref.checked = false;
        });
      },
      setValue: (refs, values) => {
        refs.forEach((ref) => {
          if (values.includes(ref.id)) {
            ref.checked = true;
          }
        });
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <Container>
      <InputLabel>Dias da semana*</InputLabel>

      <FormControl onClick={clearError}>
        {ptDays.map((option, index) => (
          <FormControlLabel
            key={option.id}
            control={
              <input
                defaultChecked={defaultValue.find((dv) => dv === option.id)}
                ref={(ref) => {
                  inputRefs.current[index] = ref;
                }}
                value={option.value}
                type="checkbox"
                id={option.id}
              />
            }
            label={option.label}
          />
        ))}
      </FormControl>

      {error && <FormHelperText error>{error}</FormHelperText>}
    </Container>
  );
};

Days.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Days;
